export const USER_AUTH = "USER_AUTH";
export const QUESTIONS_UPDATE = "QUESTIONS_UPDATE";
export const UPDATE_ANSWER = "UPDATE_ANSWER";
export const INTERVIEW_FEEDBACK = "INTERVIEW_FEEDBACK";
export const USER_LOGOUT = "USER_LOGOUT";